import React, { useState } from "react";
import { Stack, TablePagination, Box, Paper, Typography, useTheme } from "@mui/material";
import TransactionWeekCard from "./TransactionWeekCard";
import TransactionsTableSkeleton from "./TransactionsTableSkeleton";

const TransactionsWeeklyList = ({ weeks, loading }) => {
  const theme = useTheme();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(4);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) {
    return <TransactionsTableSkeleton rows={3} />;
  }

  const paginatedWeeks = weeks.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "calc(100vh - 420px)",
      }}
    >
      {/* Global Header */}
      <Paper
        sx={{
          px: 2,
          py: 1,
          mb: 1,
          borderRadius: 2,
          bgcolor: theme.palette.mode === "dark" ? "grey.900" : "grey.50",
          border: `1px solid ${theme.palette.divider}`,
          flexShrink: 0,
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ flex: "0 0 250px" }}
          >
            Week Period
          </Typography>
          <Box display="flex" alignItems="center" gap={3}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ width: "100px", textAlign: "center" }}
            >
              Transactions
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ width: "120px", textAlign: "center" }}
            >
              Penalties
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ width: "120px", textAlign: "right" }}
            >
              Total Amount
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ width: "100px", textAlign: "center" }}
            >
              Status
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Scrollable Weeks List */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          pr: 0.5,
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            bgcolor: theme.palette.mode === "dark" ? "grey.900" : "grey.100",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: theme.palette.mode === "dark" ? "grey.700" : "grey.400",
            borderRadius: "4px",
            "&:hover": {
              bgcolor: theme.palette.mode === "dark" ? "grey.600" : "grey.500",
            },
          },
        }}
      >
        {weeks.length === 0 ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
          >
            <Typography variant="body2" color="text.secondary">
              No transactions found
            </Typography>
          </Box>
        ) : (
          <Stack spacing={1}>
            {paginatedWeeks.map((week) => (
              <TransactionWeekCard key={week.id} weekData={week} />
            ))}
          </Stack>
        )}
      </Box>

      {/* Pagination */}
      <Box
        sx={{
          mt: 2,
          pt: 1.5,
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <TablePagination
          component="div"
          count={weeks.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 15]}
          labelRowsPerPage="Weeks per page:"
        />
      </Box>
    </Box>
  );
};

export default TransactionsWeeklyList;
